import React from 'react';
import { useTranslation } from 'react-i18next';
// import './ContactUs.css';

const ContactUs = () => {
  const { t } = useTranslation();
  return (
    <div className="footer-link-page">
      <h1>{t('contactUs.title')}</h1>
      <p>{t('contactUs.subTitle')}</p>
      <div className="form-wrapper">
        <iframe
          src="https://docs.google.com/forms/d/e/1FAIpQLSfSe9Kv3O8WjBZDAmn38pLq-XG_Um4McRB4yBzlNImamtPdaA/viewform?embedded=true"
          width="100%"
          height="800"
          frameBorder="0"
          marginHeight="0"
          marginWidth="0"
          title={t('contactUs.contactUsForm')}
        >
          {t('common.loading')}
        </iframe>
      </div>
    </div>
  );
};

export default ContactUs;
